import React, { useState } from 'react';
import { Form, Button, Card, Container, Alert, Spinner } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import Logo from '../assets/logo.png';

const Register = () => {
    const [formData, setFormData] = useState({ name: '', email: '', password: '' });
    const [otp, setOtp] = useState('');
    const [step, setStep] = useState(1); // Step 1: Details, Step 2: OTP
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const API_URL = process.env.REACT_APP_API_URL;

    // Pehle Details submit karke OTP bhejna
    const handleRequestOtp = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            // Backend endpoint jo OTP bhejta hai
            await axios.post(`${API_URL}/send-otp`, { email: formData.email });
            setStep(2); // OTP screen par move karein
            setLoading(false);
        } catch (err) {
            setError(err.response?.data?.detail || "Failed to send OTP. Check your email.");
            setLoading(false);
        }
    };

    // OTP Verify karke Final Registration karna
    const handleVerifyAndRegister = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            // Backend endpoint jo OTP verify karke register karta hai
            await axios.post(`${API_URL}/register-verify`, { 
                ...formData, 
                otp: otp 
            });
            setSuccess(true);
            setLoading(false);
            setTimeout(() => navigate('/login'), 2000);
        } catch (err) {
            setError(err.response?.data?.detail || "Invalid OTP. Please try again.");
            setLoading(false);
        }
    };

    return (
        <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: "100vh" }}>
            <Card style={{ width: '400px' }} className="shadow-lg border-0 rounded-4">
                <Card.Body className="p-4">
                    <div className="text-center mb-4">
                        <img src={Logo} alt='Logo' className='rounded-circle mb-3' style={{width: '60px', height: '60px'}} />
                        <h3 className="fw-bold">{step === 1 ? "Create Account" : "Verify Email"}</h3>
                        <p className="text-muted small">
                            {step === 1 
                                ? "Join our community of developers" 
                                : `We've sent an OTP to ${formData.email}`}
                        </p>
                    </div>

                    {error && <Alert variant="danger" className="py-2 small">{error}</Alert>}
                    {success && <Alert variant="success" className="py-2 small">Registration Successful! Redirecting...</Alert>}
                    
                    {step === 1 ? (
                        // --- STEP 1: Registration Details ---
                        <Form onSubmit={handleRequestOtp}>
                            <Form.Group className="mb-3">
                                <Form.Label className="small fw-bold">Full Name</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    placeholder="Kuldeep Kumawat" 
                                    required 
                                    value={formData.name}
                                    onChange={(e) => setFormData({...formData, name: e.target.value})} 
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label className="small fw-bold">Email Address</Form.Label>
                                <Form.Control 
                                    type="email" 
                                    placeholder="name@example.com" 
                                    required 
                                    value={formData.email}
                                    onChange={(e) => setFormData({...formData, email: e.target.value})} 
                                />
                            </Form.Group>

                            <Form.Group className="mb-4">
                                <Form.Label className="small fw-bold">Password</Form.Label>
                                <Form.Control 
                                    type="password" 
                                    placeholder="Create a strong password" 
                                    required 
                                    value={formData.password}
                                    onChange={(e) => setFormData({...formData, password: e.target.value})} 
                                />
                            </Form.Group>

                            <Button variant="primary" className="w-100 py-2 fw-bold shadow-sm rounded-pill" type="submit" disabled={loading}>
                                {loading ? <Spinner animation="border" size="sm" /> : "Get OTP"}
                            </Button>
                        </Form>
                    ) : (
                        // --- STEP 2: OTP Verification ---
                        <Form onSubmit={handleVerifyAndRegister}>
                            <Form.Group className="mb-4">
                                <Form.Label className="small fw-bold text-center d-block">Enter 6-Digit OTP</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    placeholder="· · · · · ·" 
                                    className="text-center fs-4 fw-bold"
                                    maxLength="6"
                                    required 
                                    value={otp}
                                    onChange={(e) => setOtp(e.target.value)} 
                                />
                            </Form.Group>

                            <Button variant="success" className="w-100 py-2 fw-bold shadow-sm rounded-pill mb-3" type="submit" disabled={loading}>
                                {loading ? <Spinner animation="border" size="sm" /> : "Verify & Register"}
                            </Button>
                            
                            <div className="text-center">
                                <Button variant="link" className="small text-decoration-none p-0" onClick={() => setStep(1)}>
                                    Back to Details
                                </Button>
                            </div>
                        </Form>
                    )}
                    
                    <div className="text-center mt-3">
                        <small>Already have an account? <Link to="/login">Login here</Link></small>
                    </div>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default Register;